/* eslint-disable react/jsx-no-target-blank */

import { FC } from 'react'
import { useLayout } from '../core'

const Footer: FC = () => {
  const { classes } = useLayout()
  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      {/* begin::Container */}
      <div className={`${classes.footerContainer} d-flex flex-column flex-md-row flex-stack`}>
        {/* begin::Copyright */}
        <div className='text-dark order-2 order-md-1'>
          <span className='text-gray-400 fw-bold me-1'>Creado por:</span>
          <a
            href='https://www.e-transport.es/'
            target='_blank'
            className='text-muted text-hover-primary fw-bold me-2 fs-6'
          >
            Ultima Milla Transportes y Logistica, SL
          </a>
        </div>
        {/* end::Copyright */}

        {/* begin::Menu */}
        <ul className='menu menu-gray-600 menu-hover-primary fw-bold order-1'>
          <li className='menu-item'>
            <a href='https://www.e-transport.es/sobre_nosotros/' target='_blank' className='menu-link px-2'>
              Sobre Nosotros
            </a>
          </li>
          <li className='menu-item'>
            <a href='https://www.e-transport.es/' target='_blank' className='menu-link px-2'>
              Contacto
            </a>
          </li>
        </ul>
        {/* end::Nav */}
      </div>
      {/* end::Container */}
    </div>
  )
}

export { Footer }
